export default "__VITE_PUBLIC_ASSET__b9a9b464__"